<template>
  <div class="learningGeneral">
    <el-card>
      <div style="display:flex">
        <div class="learningGeneral-left">
          <div class="learningGeneral-search">
            <el-cascader
              class="learningGeneral-select"
              clearable
              v-model="courseIds"
              :show-all-levels="false"
              :props="subjectTreeProps"
              placeholder="请输入所属科目"
              :options="subjectTreeList"
              @change="subjectSearchChange"
            ></el-cascader>
            <el-tree :data="ChapterTree" :props="ChapterProps" class="learningGeneral-tree">
              <span class="span-ellipsis" slot-scope="{ node, data }">
                <span :title="data.name" @click="getChapterMaterialsList(data)">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="learningGeneral-right">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学习概况" name="first" class="tab-type">
              <div>
                  <div style="height:151px;">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="learningGeneral-analyse">
                      <div>签到人数</div>
                      <div class="analyse">
                        <span class="learningGeneral-number">62</span>/77
                      </div>
                      <el-progress :percentage="50"></el-progress>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="learningGeneral-analyse">
                      <div>课堂练习做题人数</div>
                      <div class="analyse">
                        <span class="learningGeneral-number">62</span>/77
                      </div>
                      <el-progress :percentage="50"></el-progress>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="learningGeneral-analyse">
                      <div>客户作业做题人数</div>
                      <div class="analyse">
                        <span class="learningGeneral-number">62</span>/77
                      </div>
                      <el-progress :percentage="50"></el-progress>
                    </div>
                  </el-col>
                </el-row>
                </div>

                <div>
                  <el-table
                    ref="multipleTable"
                    :data="studyList.records"
                    style="width: 100%;"
                    row-key="id"
                    border
                  >
                    <el-table-column prop="questionTypeName" label="学员姓名" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="title" show-overflow-tooltip label="学院电话"></el-table-column>
                    <el-table-column
                      prop="answer"
                      label="签到状态"
                      align="center"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="answer"
                      label="签到时间"
                      align="center"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="answer"
                      label="课堂练习/正确率"
                      align="center"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      prop="answer"
                      label="课后练习/正确率"
                      align="center"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    layout="prev, pager, next, jumper,  total, sizes"
                    style="margin-top: 20px;text-align: left;"
                    :total="studyList.total"
                    :page-size="studyList.pageSize"
                    :page-sizes="[10, 20, 30, 40]"
                    :current-page="studyList.pageNumber"
                    @size-change="studySizeChange"
                    @current-change="studyCurrentChange"
                  ></el-pagination>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="课堂练习分析" name="second" class="tab-type"></el-tab-pane>

            <el-tab-pane label="课后作业分析" name="third" class="tab-type"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      courseIds: [],
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      ChapterTree: [],
      ChapterProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      activeName: "first",
      chapterId: "",
      studyList: [],
      studySearch: {
        pageNumber: 1,
        pageSize: 10
      }
    };
  },
  computed: {},
  methods: {
    subjectSearchChange() {
      console.log("courseIds", this.courseIds);
      this.searchForm.courseId = this.courseIds[2];
      this.getTree();
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
          this.searchForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
          this.getTree();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTree() {
      this.api.chapter
        .getChapterSelectListByCourse({ courseId: this.searchForm.courseId })
        .then(result => {
          this.ChapterTree = result.data;
          this.getChapterMaterialsList(this.ChapterTree[0].children[0]);
          this.courseIds = this.ChapterTree[0].children[0];
          this.activeName = "first";
        })
        .catch(error => {
          console.log(error);
        });
    },
    studySizeChange(pageSize) {
      this.studySearch.pageSize = pageSize;
    },
    studyCurrentChange(pageNumber) {
      this.studySearch.pageNumber = pageNumber;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name == "first") {
        this.getChapterMaterialsList(this.courseIds, 1);
      }
      if (tab.name == "second") {
        this.getChapterMaterialsList(this.courseIds, 2);
      }
      if (tab.name == "third") {
        this.getChapterMaterialsList(this.courseIds, 3);
      }
      if (tab.name == "fourth") {
        this.getChapterMaterialsList(this.courseIds, 4);
      }
      if (tab.name == "five") {
        this.getChapterMaterialsList(this.courseIds, 5);
      }
      if (tab.name == "six") {
        this.getChapterMaterialsList(this.courseIds, 6);
      }
    }
  },
  watch: {},
  mounted() {
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.learningGeneral {
  background-color: #fff;
}
.learningGeneral-left {
  width: 20%;
  border-right: 1px solid rgba(238, 238, 238, 1);
}
.learningGeneral-right {
  width: 80%;
}
.tab-type {
  padding: 20px;
  /* padding-top: 10px; */
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 48px;
  line-height: 48px;
}
.left-top-text {
  float: left;
}
.left-top-botton {
  margin-top: 10px;
  float: right;
}
.learningGeneral-search {
  padding: 0px 20px;
}
.learningGeneral-select {
  width: 100%;
  margin-top: 20px;
}
.learningGeneral-tree {
  font-size: 13px;
  margin-top: 20px;
  padding-bottom: 20px;
  color: #a2aabc;
}
.learningGeneral-icon {
  margin: 0px 10px;
  font-size: 18px;
  color: #409eff;
}
.classRoomButton {
  height: 32px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 14px;
}
.learningGeneral-analyse {
  padding: 20px;
  border: 1px solid rgba(238, 238, 238, 1);
  height: 80px;
}
.learningGeneral-number {
  font-size: 28px;
}
.analyse {
  margin-top: 10px;
  margin-bottom: 10px;
}
.learningGeneral-table {
  margin-top: 20px;
}
</style>
<style lang="less">
.learningGeneral {
  .el-card__body {
    padding: 0px !important;
  }
  .el-tabs__nav-scroll {
    height: 49px !important;
    line-height: 49px;
  }
  .el-tabs__nav {
    margin-left: 20px;
  }
  .previewBox {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    .el-dialog {
      width: 320px;
      height: 606px;
      margin: inherit;
      border-radius: 50px;
      margin-top: 0 !important;
      .el-dialog__header {
        height: 0;
        width: 0;
        padding: 0;
        opacity: 0;
      }
      .el-dialog__body {
        padding: 0;
        .mobileBg {
          width: 324px;
          height: 606px;
        }
        .content {
          position: relative;
          top: -540px;
          left: 22px;
          width: 280px;
          line-height: 20px;
          font-size: 15px;
          height: 460px !important;
          overflow-y: scroll;
          margin: 0;
          overflow-x: hidden;
          .content-top {
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
          }
          .content-buttom {
            height: 28px;
            width: 40px;
            line-height: 28px;
            border: 1px solid rgba(238, 238, 238, 1);
            color: #37aefe;
            text-align: center;
            cursor: pointer;
            position: relative;
            top: -35px;
            left: 225px;
          }
          .attachList {
            margin-bottom: 20px;
            a {
              text-decoration: none;
            }
          }
        }
      }
    }
    img {
      max-width: 100%;
    }
  }
  .learningGeneral-tree {
    .el-tree-node__label {
      font-size: 13px;
      color: #a2aabc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classStudy/learningGeneral.vue